import React from "react";
import { IIcons } from "./icons";

const TrashBin = ({ fillColor }: IIcons.IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill={fillColor}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2 5.10864C2 4.69443 2.33579 4.35864 2.75 4.35864H16.25C16.6642 4.35864 17 4.69443 17 5.10864C17 5.52286 16.6642 5.85864 16.25 5.85864H2.75C2.33579 5.85864 2 5.52286 2 5.10864Z"
        fill="#DA0507"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8 2.85864C7.80109 2.85864 7.61032 2.93766 7.46967 3.07831C7.32902 3.21896 7.25 3.40973 7.25 3.60864V4.35864H11.75V3.60864C11.75 3.40973 11.671 3.21896 11.5303 3.07831C11.3897 2.93766 11.1989 2.85864 11 2.85864H8ZM13.25 4.35864V3.60864C13.25 3.01191 13.0129 2.43961 12.591 2.01765C12.169 1.5957 11.5967 1.35864 11 1.35864H8C7.40326 1.35864 6.83097 1.5957 6.40901 2.01765C5.98705 2.43961 5.75 3.01191 5.75 3.60864V4.35864H4.25C3.83579 4.35864 3.5 4.69443 3.5 5.10864V15.6086C3.5 16.2054 3.73705 16.7777 4.15901 17.1996C4.58097 17.6216 5.15326 17.8586 5.75 17.8586H13.25C13.8467 17.8586 14.419 17.6216 14.841 17.1996C15.2629 16.7777 15.5 16.2054 15.5 15.6086V5.10864C15.5 4.69443 15.1642 4.35864 14.75 4.35864H13.25ZM5 5.85864V15.6086C5 15.8076 5.07902 15.9983 5.21967 16.139C5.36032 16.2796 5.55109 16.3586 5.75 16.3586H13.25C13.4489 16.3586 13.6397 16.2796 13.7803 16.139C13.921 15.9983 14 15.8076 14 15.6086V5.85864H5Z"
        fill="#DA0507"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8 8.10864C8.41421 8.10864 8.75 8.44443 8.75 8.85864V13.3586C8.75 13.7729 8.41421 14.1086 8 14.1086C7.58579 14.1086 7.25 13.7729 7.25 13.3586V8.85864C7.25 8.44443 7.58579 8.10864 8 8.10864Z"
        fill="#DA0507"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11 8.10864C11.4142 8.10864 11.75 8.44443 11.75 8.85864V13.3586C11.75 13.7729 11.4142 14.1086 11 14.1086C10.5858 14.1086 10.25 13.7729 10.25 13.3586V8.85864C10.25 8.44443 10.5858 8.10864 11 8.10864Z"
        fill="#DA0507"
      />
    </svg>
  );
};

export default TrashBin;
